import { useTsRest } from '../context/ts-rest.js';

/**
 * The navigation config is static within a session — it depends only on who
 * the user is — so it is cached well beyond the aggressive global refetch
 * defaults, and the shared query key keeps every consumer on one cache entry.
 */
export function useAddInConfig() {
    const tsr = useTsRest();

    return tsr.addIn.getConfig.useQuery({
        queryKey: ['add-in', 'getConfig'],
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
}
